import React from 'react';
import t from '../../../util/translation/translation';
import useConfig from '../../../util/useConfig';

// Shared heading for the sign-in screens (SMS login, email login and
// password reset): the club's logo with a welcome line under it.
const AccountHeader = () => {
  const config = useConfig();
  return (
    <div className="account__head">
      {config.club_logo && (
        <img
          className="account__head-logo"
          src={config.club_logo}
          alt={config.club_name}
        />
      )}
      <span className="account__head-welcome">{t('LoginPage.welcomeTo')}</span>
      <h3 className="account__title">{config.club_name}</h3>
    </div>
  );
};

export default AccountHeader;
